import { render, staticRenderFns } from "./order-view.vue?vue&type=template&id=53602fa8&scoped=true&"
import script from "./order-view.vue?vue&type=script&lang=js&"
export * from "./order-view.vue?vue&type=script&lang=js&"
import style0 from "./order-view.vue?vue&type=style&index=0&id=53602fa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53602fa8",
  null
  
)

export default component.exports